import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../../styles/BaseFare.scss";
import { baseURL } from "../../BaseUrl";
import * as HeaderAuthentication from "../../HeaderAuthentication";
import Select from "react-select";
import { optionsUnitList, optionsMOTTypes } from "../../DropdownsData";
import { useDispatch, useSelector } from "react-redux";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import SbAddBtn, { SBSaveUpdateBtn } from "../../SbButtons/SbAddBtn";
import SbCancelBtn from "../../SbButtons/SbCancelBtn";
import { FloatingLabel } from "react-bootstrap";
import { addStateName, loadCountryData, loadZoneList } from "../../../redux/action";

function AddZone(props) {

    let dispatch = useDispatch();
    const { getCountryName } = useSelector((state) => state.data);
    const { zoneList } = useSelector((state) => state.data);
    
    const [selectedCountryName, setSelectedCountryName] = useState(
        {
            value: "",
            label: "",
        })
    const [selectedZoneName, setSelectedZoneName] = useState(
        {
            value: "",
            label: "",
        })
    const [stateName, setStateName] = useState("")
    useEffect(() => {
        dispatch(loadCountryData())
        dispatch(loadZoneList())
    }, [])

    const handleSaveStateName = (e) => {
        e.preventDefault()

        let data = [];
        (stateName.split(",")).forEach(element => {
            data.push({
                "zoneId": selectedZoneName.value,
                "zoneName": selectedZoneName.label,
                "stateId": 0,
                "stateName": element,
                "countryID": selectedCountryName.value,
                "countryName": selectedCountryName.label,
                "countryCode": props.getAllStateName[0].countryCode
            });
        });
        let postData = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postTravelizeAuth,
            body: JSON.stringify(data)
        }
        console.log(data, 'data')
        dispatch(addStateName(postData, handleStateClose))
    }

    const handleStateClose = () => {
        props.handleStateClose();
    };

    return (
        <div>
            <Modal
                show={props.showState}
                onHide={props.handleStateClose}
                className="main_model add-edit-basefare-model"
            >
                <div className="add-edit-basefare-heading">
                    <h6 className="add-edit-basefare-head">
                        ADD STATE
                    </h6>
                    <i className="fa fa-times" onClick={handleStateClose} />
                </div>
                <form>
                    <div className="container add-edit-basefare">
                        <div className="product-inputs">
                            <div className="mb-3" style={{ position: "relative" }}>
                                <FloatingLabel
                                    label="Select Country"
                                    className={`${selectedCountryName
                                        ? "float-visible-select"
                                        : "float-hidden float-select"
                                        }`}
                                >
                                    <Select
                                        className="react-select-container-list model-select"
                                        classNamePrefix="react-select-list"
                                        options={getCountryName}
                                        placeholder="Select Country"
                                        value={selectedCountryName.value && selectedCountryName}
                                        onChange={(selectedOption) => { setSelectedCountryName(selectedOption) }}
                                        isSearchable={true}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="mb-3" style={{ position: "relative" }}>
                                <FloatingLabel
                                    label="Select Zone"
                                    className={`${selectedZoneName
                                        ? "float-visible-select"
                                        : "float-hidden float-select"
                                        }`}
                                >
                                    <Select
                                        className="react-select-container-list model-select"
                                        classNamePrefix="react-select-list"
                                        options={zoneList}
                                        placeholder="Select Zone"
                                        value={selectedZoneName.value && selectedZoneName}
                                        onChange={(selectedOption) => { setSelectedZoneName(selectedOption) }}
                                        isSearchable={true}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="mb-3" style={{ position: "relative" }}>
                                <label className="float-label">State Name</label>
                                <input
                                    type="text"
                                    className="form-control form add-basefare-input"
                                    id="exampleFormControlInput1"
                                    name="apiKey"
                                    value={stateName}
                                    placeholder="Enter State Name"
                                    onChange={(e) => { setStateName(e.target.value) }}
                                />
                            </div>
                        </div>
                    </div>
                </form>
                <div className="btns-save-cancel">
                    <SBSaveUpdateBtn
                        btnName="Save"
                        onClickEffect={handleSaveStateName}
                    />
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleStateClose} />
                </div>
            </Modal>
        </div>
    );
}

export default AddZone;
